const placeholderImages = document.querySelectorAll(
  ".custom_iframe_placeholder"
);
placeholderImages.forEach((p) => {
  p.addEventListener("click", function (e) {
    e.preventDefault();
    const iframeConnect = document.querySelector(`#${this.dataset.id}`);
    iframeConnect.src += "?autoplay=1";
    this.style.display = "none";
  });
});

const acc = document.getElementsByClassName("accordion");

for (let i = 0; i < acc.length; i++) {
  acc[i].addEventListener("click", function () {
    this.classList.toggle("active");
    var panel = this.nextElementSibling;
    panel.classList.toggle("active");
    if (panel.style.maxHeight) {
      panel.style.maxHeight = null;
    } else {
      panel.style.maxHeight = panel.scrollHeight + "px";
    }
  });
}
